import React, { useEffect, useState } from 'react';
import '../assets/css/team.css';
import '../assets/css/custom.css';
import bgImage from '../assets/Images/homeBackgroundImg.png';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import API_BASE_URL from "../../helper";

import { Autoplay } from 'swiper/modules';
function Team() {

    const [teams, setTeams] = useState([]);

    // Fetch All Team Members
    const fetchAllTeamMembers = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/team/all`);
            const data = await response.json();
            setTeams(data);
        } catch (error) {
            console.error("Failed to load Team Members", error);
        }
    };

    useEffect(() => {
        fetchAllTeamMembers();
    }, []);

    // Group Image
    const [images, setImages] = useState([]);

    // Fetch All Group
    const fetchGroupImages = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/group/all`);
            const data = await response.json();
            setImages(data);
        } catch (error) {
            console.error("Failed to load group images", error);
        }
    };

    useEffect(() => {
        fetchGroupImages();
    }, []);
    return (
        <div>
            <div id="team-hero-section" className="d-flex justify-content-center align-items-center flex-column"
                style={{ background: `url(${bgImage}) center/cover no-repeat` }}>
                <h2 className="text-uppercase hero-title">Our Team</h2>
                <p className='hero-subheading'>Our talented team works together to turn ideas into powerful websites, apps, and software.</p>
            </div>

            <section className='mt-5'>
                <div className='container'>

                    <Swiper
                        slidesPerView={1}
                        spaceBetween={30}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        modules={[Autoplay]}
                        className="outTeamSwiper"
                    >
                        {
                            images.length > 0 ?
                                images.map(img => (
                                    <SwiperSlide key={img.id}>
                                        <div className='teamGroupImg'>
                                            <img
                                                src={`${API_BASE_URL}/assets/Images/${encodeURIComponent(img.image)}`}
                                                alt='loading...'
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))
                                :
                                <p className='text-white'>No Group Images Available</p>
                        }
                    </Swiper>
                </div>
            </section>


            <section id='teamSlider' className='mt-5'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-md-8 text-center'>
                            <h2 className='text-upercase'>Our Team's</h2>
                            <p>Our team consists of young and self-motivated domain specialists who love their work and are perfectionists. We take pride in our enthusiasm and ‘can do’ attitude which always gets work done on time..</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id='aboutTeam' className='mt-5'>
                <div class="container">
                    <div className='row'>

                        {teams.length > 0 ? (
                            teams.map((team) => (
                                <div className='col-md-3 mb-2 staffImgDiv p-3' key={team.id}>
                                    <div
                                        className='p-3 h-100 position-relative'
                                        style={{
                                            backgroundImage: `url("${API_BASE_URL}/assets/Images/${encodeURIComponent(team.image)}")`,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center"
                                        }}
                                    >
                                        <div className='textDiv py-3'>
                                            <h4 className='text-center staffName text-white'>
                                                {team.name}
                                            </h4>

                                            <p className='text-uppercase fs-6 staffPosition text-center text-white'>
                                                {team.position}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No Team Members Available</p>
                        )}
                    </div>
                </div>
            </section>



        </div>
    )
}

export default Team;